<template>
  <div>
    <el-input type="password" v-model="childValue" :placeholder="placeholder" class="h-40 mw-240" :disabled="disabled" :maxlength="maxLength" @input="change"></el-input>
  </div>
</template>
<script>
  /**
   * @param Number value 绑定值
   * @param Number type 类型
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Array rules 表单验证规则
   * @param String placeholder 提示语
   * @param Number minLength 最小输入长度
   * @param Number maxLength 最大输入长度
   */
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  export default {
    props: ['type', 'value', 'name', 'disabled', 'rules', 'placeholder', 'minLength', 'maxLength', 'isNeed'],
    data() {
      return {
        childValue: ''
      }
    },
    created() {
      this.setRules()
    },
    methods: {
      initData() {
        this.childValue = this.value
      },
      setRules() {
        if (this.rules) {
          if (this.isNeed) {
            if (this.minLength) {
              this.rules[this.name].push({ validator: this.checkMinLength, trigger: 'blur' })
            }
          }
        }
      },
      checkMinLength(rule, value, callback) {
        if (value.length < this.minLength) {
          callback(new Error(`请输入${this.minLength}~${this.maxLength}位字符`))
        } else {
          callback()
        }
      },
      change(value) {
        this.$emit('input', value)
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    mixins: [modelConfig]
  }
</script>


// WEBPACK FOOTER //
// honrayPassword.vue?36664be5